import { useState } from "react";
import DatePicker from "react-datepicker";
import { ErrorMessage, Field, Form, Formik } from "formik";
import dayjs from 'dayjs';
import { toast } from "react-toastify";

const MultiFieldModal = ({
  className,
  handleCloseModal,
  fields,
  containerFieldName,
  modalTitle,
  setFieldValue,
  initialData = [],
  disabled
}) => {
  const [modalFields, setModalFields] = useState(initialData);
  const [editIndex, setEditIndex] = useState(null);

  console.log("MultiFieldModal rendered with fields:", initialData);

  const formatValues = (values) => {
    const formattedData = { ...values };
    fields.forEach((field) => {
      if (field.type === 'date' && values[field.fieldName]) {
        formattedData[field.fieldName] = dayjs(values[field.fieldName]).format('YYYY-MM');
      }
    });
    return formattedData;
  };

  const getInitialValues = () => {
    if (editIndex !== null) {
      return fields.reduce((acc, field) => {
        acc[field.fieldName] = field.type === 'date'
          ? new Date(modalFields[editIndex][field.fieldName] + "-01")
          : modalFields[editIndex][field.fieldName];
        return acc;
      }, {});
    }
    return fields.reduce((acc, field) => {
      acc[field.fieldName] = field.type === 'date' ? null : '';
      return acc;
    }, {});
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{modalTitle}</h5>
            <button type="button" className="btn-close" onClick={handleCloseModal}></button>
          </div>

          <Formik initialValues={getInitialValues()} enableReinitialize>
            {({ values, setFieldValue: setFormikFieldValue, resetForm, }) => (
              <Form>
                <div className="modal-body row" hidden={disabled}>
                  {fields
                    .filter(field => field.fieldName !== "id")
                    .map((field, index) => (
                      <div key={index} className="col-md-6 py-2">
                        <label className="form-label">{field.fieldLabel}</label>
                        {field.type === "date" ? (
                          <DatePicker
                            className={`form-control ${className}`}
                            selected={values[field.fieldName]}
                            onChange={(date) => setFormikFieldValue(field.fieldName, date)}
                            showMonthYearPicker
                            dateFormat="MM/yyyy"
                            placeholderText={field.placeholder}
                            disabled={disabled}
                          />
                        ) : field.type === "text" || field.type === "number" ? (
                          <>
                            <Field
                              name={field.fieldName}
                              className={`form-control ${className}`}
                              placeholder={field.placeholder}
                              type={field.type}
                              disabled={disabled}
                            />
                            <ErrorMessage name={field.fieldName} component="div" className="text-danger" />
                          </>
                        ) : null}
                      </div>
                    ))}
                </div>

                {modalFields.length > 0 && (
                  <div className="px-3">
                    <h6 className="mt-3" hidden={disabled}>Added Entries</h6>
                    <ul className="list-group">
                      {modalFields.map((item, index) => (
                        <li
                          className="list-group-item d-flex justify-content-between align-items-start flex-wrap"
                          key={index}
                        >
                          <div className="me-auto">
                            <div><strong>Entry {index + 1}</strong></div>
                            {fields
                              .filter((field) => field.fieldName !== "id")
                              .map((field) => (
                                <div key={field.fieldName}>
                                  <strong>{field.fieldLabel}:</strong> {item[field.fieldName]}
                                </div>
                              ))}
                          </div>

                          <div className="btn-group mt-2" role="group" hidden={disabled}>
                            <button
                              type="button"
                              className="btn btn-sm btn-warning"
                              onClick={() => setEditIndex(index)}
                            >
                              Edit
                            </button>
                            <button
                              hidden={editIndex !== null}
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                const updatedFields = modalFields.filter((_, i) => i !== index);
                                setModalFields(updatedFields);
                                setFieldValue(containerFieldName, updatedFields); 
                              }}
                            >
                              Delete
                            </button>

                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {modalFields.length === 0 && (
                  <li className="list-group-item text-center">
                    No entries added yet.
                  </li>
                )}

                <div className="modal-footer">
                  {editIndex !== null && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      hidden={disabled}
                      onClick={() => {
                        const formatted = formatValues(values);
                        const updatedFields = [...modalFields];
                        updatedFields[editIndex] = formatted;
                        setModalFields(updatedFields);
                        setEditIndex(null);
                      }}
                    >
                      Update
                    </button>
                  )}

                  <button
                    type="button"
                    hidden={disabled}
                    className="btn btn-primary"
                    onClick={() => {
                      const formatted = formatValues(values);
                      const isEmpty = Object.entries(formatted)
                        .filter(([key]) => key !== 'id')
                        .some(([, val]) => val === '' || val === null);

                      if (isEmpty) {
                        toast.error("Please fill all fields before adding.");
                        return;
                      }

                      setModalFields([...modalFields, formatted]);
                      resetForm();
                    }}
                  >
                    <i className="fas fa-plus px-2"></i> Add
                  </button>

                  <button
                    type="button"
                    hidden={disabled}
                    className="btn btn-success"
                    onClick={() => {
                      if (modalFields.length > 0) {
                        console.log('---------------------------------');
                        console.log(containerFieldName, modalFields);
                        console.log('---------------------------------');
                        setFieldValue(containerFieldName, modalFields);
                      }
                      handleCloseModal();
                    }}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setEditIndex(null);
                      handleCloseModal();
                    }}
                  >
                    Close
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default MultiFieldModal;
